export default __webpack_public_path__ + "static/media/grupo_societario.a32aa25d.svg";